import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { GetSalaryStructureSDIsGraphRequest, GetSalaryStructureSDIsGraphResponse } from '../types';

export const getSalaryStructureSDIsQuery = gql`
  query PayrollGetSalaryComponentSDIs($input: PayrollGetSalaryComponentSDIsInput!) {
    payrollGetSalaryComponentSDIs(input: $input) {
      data {
        payrolls {
          merchantId
          tenantId
          data {
            annualEarningsData {
              name
              earningType
              description
              amount
              payType
              source
            }
            earnings {
              name
              earningType
              description
              amount
              payType
              displayBehaviourV1 {
                showZero
                visibleToEmployee
                displayName
              }
              source
              taxBehaviourV1 {
                taxExemptionSection
                taxDeductionBehaviour
                taxExemptInNewRegime
                taxExemptInOldRegime
              }
            }
            deductions {
              name
              deductionType
              description
              amount
              deductFrom
              displayBehaviourV1 {
                showZero
                visibleToEmployee
                displayName
              }
              source
              taxBehaviourV1 {
                taxExemptionSection
                taxDeductionBehaviour
                taxExemptInNewRegime
                taxExemptInOldRegime
              }
            }
            compensation {
              ctcComponent {
                earningComponents {
                  name
                  earningType
                  description
                  amount
                  payType
                  displayBehaviourV1 {
                    showZero
                    visibleToEmployee
                    displayName
                  }
                  source
                }
                statutoryComponents {
                  amount
                  type
                }
              }
              nonCtcComponent {
                statutoryComponents {
                  amount
                  type
                }
              }
              monthlyCtc
            }
          }
        }
        pagination {
          currentPage
          totalPages
          pageSize
          totalItems
        }
      }

      code
      success
      message
    }
  }
`;

export const getSalaryStructureSDIs = (queryVariables: GetSalaryStructureSDIsGraphRequest) => {
  return graphQLApi<GetSalaryStructureSDIsGraphResponse, GetSalaryStructureSDIsGraphRequest>({
    query: getSalaryStructureSDIsQuery,
    queryVariables,
  });
};

export default getSalaryStructureSDIs;
